import { useState } from 'react';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { TagsSelector } from '../../ItemSelector';
import {
    FieldLabelWithError,
    FieldWithErrorProps,
} from './FieldLabelWithError';
import { useDisableFormContext } from '../DisableContext';
import { sortTags, Tag } from '~/util/types/tags';
import { LevelGPTags, TagsBase } from '~/partials/Tags';

export function LevelTagsField({
    forceDisabled,
    tagOptions = {},
    ...labelProps
}: {
    forceDisabled?: boolean;
    tagOptions?: Partial<
        Omit<TagsBase<Tag>, 'items' | 'editable' | 'onEdit' | 'item'>
    >;
} & FieldWithErrorProps) {
    const field = useFieldContext<Tag[] | null>();
    const [tagsSelectorOpen, setTagsSelectorOpen] = useState(false);
    const disabled = useDisableFormContext() || forceDisabled;

    return (
        <FieldLabelWithError<Tag | null> {...labelProps}>
            <LevelGPTags
                items={field.state.value ?? []}
                editable={!disabled}
                highContrast
                onEdit={() => setTagsSelectorOpen(true)}
                onRemove={(tag) =>
                    field.handleChange(
                        field.state.value?.filter((item) => item != tag) ??
                            null,
                    )
                }
                {...tagOptions}
            />
            <TagsSelector
                open={tagsSelectorOpen}
                onOpenChange={setTagsSelectorOpen}
                initial={field.state.value ?? []}
                onSave={(items) => {
                    const tags = items instanceof Array ? items : [items];
                    field.handleChange(tags?.sort(sortTags) ?? null);
                    setTagsSelectorOpen(false);
                }}
                tagOptions={tagOptions}
            />
        </FieldLabelWithError>
    );
}
